// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__aIeo5","footer__links":"footer_footer__links__QsOv2"};